import type { MarketingAvatarSize } from '../../assets/marketing/avatars/marketingAvatarAssets';
import './landingRef.css';

type Props = {
  src: string;
  size?: MarketingAvatarSize;
  className?: string;
  alt?: string;
};

/** Circular face for marketing phone mockups and social UI. */
export function Avatar({ src, size = 'md', className = '', alt = '' }: Props) {
  return (
    <img
      className={`avatar avatar-${size} ${className}`.trim()}
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      draggable={false}
    />
  );
}
